import { Ruler, type LucideIcon } from "lucide-react";

import {
  VIEWPORT_TOOL_KINDS,
  VIEWPORT_TOOLSET_IDS,
  VIEWPORT_TOOLSET_PLACEMENTS,
  type ViewportToolDefinition,
  type ViewportToolsetDefinition,
} from "@/viewport-tools/core/contracts";

export const SCALE_TOOL_IDS = {
  preset: "scale-preset",
  calibrate: "scale-calibrate",
} as const;

export type ScaleToolId = (typeof SCALE_TOOL_IDS)[keyof typeof SCALE_TOOL_IDS];

export const CALIBRATION_METHOD_IDS = {
  preset: "preset",
  manual: "manual",
} as const;

export type CalibrationMethodId =
  (typeof CALIBRATION_METHOD_IDS)[keyof typeof CALIBRATION_METHOD_IDS];

export interface ScaleToolDefinition
  extends ViewportToolDefinition<ScaleToolId, typeof VIEWPORT_TOOLSET_IDS.scale> {
  icon: LucideIcon;
}

export type ScaleToolsetDefinition = ViewportToolsetDefinition<
  typeof VIEWPORT_TOOLSET_IDS.scale,
  ScaleToolId
>;

export const SCALE_TOOL_DEFINITIONS: Record<ScaleToolId, ScaleToolDefinition> = {
  [SCALE_TOOL_IDS.preset]: {
    id: SCALE_TOOL_IDS.preset,
    label: "Preset",
    toolsetId: VIEWPORT_TOOLSET_IDS.scale,
    kind: VIEWPORT_TOOL_KINDS.workflow,
    icon: Ruler,
  },
  [SCALE_TOOL_IDS.calibrate]: {
    id: SCALE_TOOL_IDS.calibrate,
    label: "Calibrate",
    toolsetId: VIEWPORT_TOOLSET_IDS.scale,
    kind: VIEWPORT_TOOL_KINDS.workflow,
    icon: Ruler,
  },
};

export const SCALE_TOOLSET: ScaleToolsetDefinition = {
  id: VIEWPORT_TOOLSET_IDS.scale,
  label: "Scale",
  placement: VIEWPORT_TOOLSET_PLACEMENTS.leftRail,
  tools: [SCALE_TOOL_IDS.preset, SCALE_TOOL_IDS.calibrate],
};

export function getScaleToolDefinition(toolId: ScaleToolId): ScaleToolDefinition {
  return SCALE_TOOL_DEFINITIONS[toolId];
}

export function getScaleToolDefinitions(
  toolset: ScaleToolsetDefinition = SCALE_TOOLSET
): ScaleToolDefinition[] {
  return toolset.tools.map((toolId) => SCALE_TOOL_DEFINITIONS[toolId]);
}
